import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/tailwind.css'
import axios from 'axios'

// Import all components from flowbite-vue
import {
  FwbButton,
  FwbModal,
  FwbInput,
  FwbTextarea,
  FwbSelect,
  FwbCheckbox,
  FwbAlert,
  FwbSpinner,
  FwbDropdown,
  FwbListGroup,
  FwbListGroupItem,
  FwbTooltip,
  FwbCard,
  FwbBadge,
  FwbToggle,
  FwbToast,
  FwbToastProvider
} from 'flowbite-vue'

// Import Flowbite CSS
import 'flowbite/dist/flowbite.css'

const app = createApp(App)

// Register Flowbite components globally
const components = {
  FwbButton,
  FwbModal,
  FwbInput,
  FwbTextarea,
  FwbSelect,
  FwbCheckbox,
  FwbAlert,
  FwbSpinner,
  FwbDropdown,
  FwbListGroup,
  FwbListGroupItem,
  FwbTooltip,
  FwbCard,
  FwbBadge,
  FwbToggle,
  FwbToast,
  FwbToastProvider
}

Object.entries(components).forEach(([name, component]) => {
  app.component(name, component)
})

app.use(store)
app.use(router)

app.mount('#app') 